import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgOrderReward',
})
export default class CmgOrderReward extends Vue {
  @Prop({ required: true, type: String })
  name!: string;

  @Prop({ default: false, type: Boolean })
  removable!: boolean;

  get iconImageUrl(): string {
    return this.$appStore.state.cms.images.logos.medallionFluted.default;
  }

  get removePromoImageUrl(): string {
    return this.$appStore.state.cms.images.buttons.closeSmall.default;
  }

  onClickRemove() {
    this.$emit('remove');
  }
}
